import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').ScreensaverEntity,
 *   ui: import('./ui').ScreensaverUIReducer,
 * }} ScreensaverReducer
 */

export default combineReducers({
  data,
  ui,
});
